import axios from "axios";
import { getToken, getUser } from "../Utils/Common";
import token_valid from "./TokenValid";

//get sub order person by paging
const getSubOrderPersonByPaging = async (offset, pageSize, filter) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/sub-order-person/all/" +
          offset +
          "/" +
          pageSize,
        {
          personName: filter._name ? filter._name.trim() : null,
          email: filter._email ? filter._email.trim() : null,
          phone: filter._phone ? filter._phone.trim() : null,
          address: filter._address ? filter._address.trim() : null,
          status: filter._status ? filter._status.trim() : null,
          outputImportIds:
            filter._outputImportIds && filter._outputImportIds.length > 0
              ? filter._outputImportIds
              : null,
          inputImportIds:
            filter._inputImportIds && filter._inputImportIds.length > 0
              ? filter._inputImportIds
              : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data.content);
        return response.data;
      })
      .catch((error) => {
        return "Something went wrong...";
      });
  }
};

//add sub order person
const addSubOrderPerson = async (values) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    //get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/sub-order-person/add",
        {
          personName: values._name,
          phone: values._phone,
          address: values._address,
          email: values._email,
          status: "ACTIVE",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        // setUserSession(response.data.token, response.data.user)
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("add sub order person error " + error);
        return false;
      });
  }
};

//get Sub Order Person by Id
const getSubOrderPersonById = async (personId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/sub-order-person/" + personId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Sales Person " + error);
        return "Something went wrong...";
      });
  }
};

const addBulkPayment = async (values) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    let user = getUser();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/bulk-payment/add",
        {
          personId: values.personId,
          amount: values.amount,
          note: values.note,
          addedBy: user.username,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("addBulkPayment error:", error);
        return null;
      });
  }
};

const getBulkPaymentsByPerson = async (personId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/bulk-payment/person/" + personId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("getBulkPaymentsByPerson error:", error);
        return [];
      });
  }
};

const sendBulkPaymentApproval = async (paymentId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/bulk-payment/send-approval/" + paymentId,
        { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token } }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("sendBulkPaymentApproval error:", error);
        return false;
      });
  }
};

const approveBulkPayment = async (paymentId, isApproved) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/bulk-payment/approve/" + paymentId + "/" + isApproved,
        { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token } }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("approveBulkPayment error:", error);
        return false;
      });
  }
};

const markBulkPaymentAsPaid = async (paymentId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/bulk-payment/mark-as-paid/" + paymentId,
        { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token } }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("markBulkPaymentAsPaid error:", error);
        return false;
      });
  }
};

const deleteBulkPayment = async (paymentId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(
        process.env.REACT_APP_API_URL + "/api/bulk-payment/delete/" + paymentId,
        { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token } }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("deleteBulkPayment error:", error);
        return false;
      });
  }
};

//update sub order person
const updateSubOrderPerson = async (personId, values) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .put(
        process.env.REACT_APP_API_URL + "/api/sub-order-person/update",
        {
          personId: personId,
          personName: values._name,
          phone: values._phone,
          address: values._address,
          email: values._email,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        console.log("update sub order person error " + error);
        return false;
      });
  }
};

const getSubOrderPersonWarehouses = async (personId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/sub-order-person/warehouses/" + personId,
        { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token } }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("getSubOrderPersonWarehouses error:", error);
        return [];
      });
  }
};

const assignSubOrderPersonWarehouses = async (personId, warehouseIds) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .put(
        process.env.REACT_APP_API_URL + "/api/sub-order-person/assign-warehouses/" + personId,
        warehouseIds,
        { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token } }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("assignSubOrderPersonWarehouses error:", error);
        return null;
      });
  }
};

const removeSubOrderPersonWarehouse = async (personId, warehouseId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(
        process.env.REACT_APP_API_URL + "/api/sub-order-person/remove-warehouse/" + personId + "/" + warehouseId,
        { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token } }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("removeSubOrderPersonWarehouse error:", error);
        return null;
      });
  }
};

export {
  getSubOrderPersonByPaging,
  addSubOrderPerson,
  getSubOrderPersonById,
  updateSubOrderPerson,
  addBulkPayment,
  getBulkPaymentsByPerson,
  sendBulkPaymentApproval,
  approveBulkPayment,
  markBulkPaymentAsPaid,
  deleteBulkPayment,
  getSubOrderPersonWarehouses,
  assignSubOrderPersonWarehouses,
  removeSubOrderPersonWarehouse,
};
